import moment from "moment";
import { Space, Tag } from "antd";
import { Error, Tick } from "icons";
import styles from "./style.module.scss";
import { PlanID } from "utils/constants";

const alphabetSort = (key) => (a, b) => a[key].localeCompare(b[key]);
const numberSort = (key) => (a, b) => a[key] - b[key];
const dateSort = (key) => (a, b) => new Date(a[key]) - new Date(b[key]);

function role(roleId) {
  if (roleId === 4) {
    return "Coach";
  } else if (roleId === 5) {
    return "Striker";
  } else {
    return "";
  }
}

export const userListColumns = [
  {
    title: "User Id",
    dataIndex: "id",
    key: "id",
    width: "4%",
    sorter: numberSort("id"),
    responsive: ["lg"],
  },
  {
    title: "User Name",
    dataIndex: "firstName",
    key: "firstName",
    width: "7%",
    sorter: alphabetSort("firstName"),
    render: (keyValue, row) => (
      <div>
        {row.firstName} {row.lastName}
      </div>
    ),
  },
  {
    title: "Email Address",
    dataIndex: "email",
    key: "email",
    width: "12%",
    ellipsis: true,
    sorter: alphabetSort("email"),
  },
  {
    title: "Role",
    dataIndex: "roleId",
    key: "roleId",
    width: "4%",
    render: (data) => role(data),
    // sorter: alphabetSort("role"),
  },
  {
    title: "Last Activity",
    dataIndex: "sessionUpdatedAt",
    key: "sessionUpdatedAt",
    width: "8%",
    render: (date) => (date ? moment(date).format("DD-MM-YYYY") : ""),
    // sorter: dateSort("sessionUpdatedAt"),
    responsive: ["xl"],
  },
  {
    title: "Total Capture",
    dataIndex: "videoCount",
    key: "videoCount",
    width: "7%",
    // sorter: numberSort("videoCount"),
  },
  {
    title: "Last Communicated",
    dataIndex: "lastCommunicated",
    key: "lastCommunicated",
    width: "11%",
    render: (date) => (date ? moment(date).format("DD-MM-YYYY") : ""),
    // sorter: dateSort("lastCommunicated"),
    responsive: ["xl"],
  },
  {
    title: "Platform",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "5%",
    render: (data) => (
      <div style={{ textTransform: data !== "ios" && "capitalize" }}>
        {data?.toLowerCase() === "ios" ? "iOS" : data}
      </div>
    ),
    responsive: ["xl"],
  },
  {
    title: "Plan",
    dataIndex: "subscriptionId",
    key: "subscriptionId",
    width: "5%",
    render: (data) => <div>{PlanID[data]}</div>,
  },
  {
    title: "Duration",
    dataIndex: "subscriptionId",
    key: "subscriptionId",
    width: "5%",
    render: (data) => <div>{PlanID[data]}</div>,
  },
  // {
  //   title: "Subscription Start",
  //   dataIndex: "Subscription Start",
  //   key: "Subscription Start",
  //   width: "8%",
  //   render: (date: any) => moment(date).format("DD/MM/YYYY"),
  // },
  {
    title: "Subscription Status",
    dataIndex: "is_expired",
    key: "is_expired",
    width: "8%",
    render: (_, record) => {
      const isStatusActive = !record.is_expired;
      const status = record.is_expired ? "Expired" : "Active";
      const colors = {
        lightRed: "#F63E504D",
        lightGreen: "#A8D3BF",
        red: "#F63E50",
        green: "#16A665",
      };
      const { lightGreen, lightRed, red, green } = colors;

      const Icon = isStatusActive ? Tick : Error;
      const color = isStatusActive ? lightGreen : lightRed;
      return (
        <Space size="middle">
          <Tag
            icon={<Icon height={14} width={14} />}
            color={color}
            bordered={true}
            style={{
              color: isStatusActive ? green : red,
              border: `1px solid ${isStatusActive ? green : red}`,
              display: "flex",
              alignItems: "center",
              gap: "3px",
              justifyContent: "center",
            }}
            data-attribute="subscription-status-tag"
          >
            {status}
          </Tag>
        </Space>
      );
    },
  },
  // {
  //   title: "Subscription End",
  //   dataIndex: "studio_expiry",
  //   key: "studio_expiry",
  //   width: "8%",
  //   render: (date) => (date ? moment(date).format("DD-MM-YYYY") : ""),
  //   sorter: dateSort("studio_expiry"),
  // },

  {
    title: "Action",
    dataIndex: "preview",
    key: "preview",
    align: "center", // Align center for this column
    width: "5%",
  },
];

export const userListTableDummyValues = [
  {
    id: "1",
    name: "Alfie Christopher",
    email: "alfie.c1@gmail.com",
    subscriptionStart: "20/01/2022",
    subscriptionEnd: "20/03/2022",
    plan: "3 months",
    activeDate: "20/02/2022",
  },
  {
    id: "2",
    name: "Alfie Christopher",
    email: "alfie.c1@gmail.com",
    subscriptionStart: "20/01/2022",
    subscriptionEnd: "20/03/2022",
    plan: "3 months",
    activeDate: "20/02/2022",
    active: true,
  },
  {
    id: "3",
    name: "Alfie Christopher",
    email: "alfie.c1@gmail.com",
    subscriptionStart: "20/01/2022",
    subscriptionEnd: "20/03/2022",
    plan: "3 months",
    activeDate: "20/02/2022",
  },
  {
    id: "4",
    name: "Alfie Christopher",
    email: "alfie.c1@gmail.com",
    subscriptionStart: "20/01/2022",
    subscriptionEnd: "20/03/2022",
    plan: "3 months",
    activeDate: "20/02/2022",
  },
  {
    id: "5",
    name: "Alfie Christopher",
    email: "alfie.c1@gmail.com",
    subscriptionStart: "20/01/2022",
    subscriptionEnd: "20/03/2022",
    plan: "3 months",
    activeDate: "20/02/2022",
  },
];
